function handleBackofficeSessionExpired(responseData) {
    if(responseData?.valid === false && responseData.error === "SESSION_EXPIRED") {
        window.location.assign("/login");
        return true;
    }
    return false;
}

export default handleBackofficeSessionExpired;
